import { useParams, useNavigate, Link } from 'react-router-dom';
import { useEditUser } from '../../../hooks/users/useEditUser.js';
import { useCompaniesSelect } from '../../../hooks/company/useCompaniesSelect.js';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import ValidationErrors from '../../../components/alerts/ValidationErrors.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function EditUser() {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    } = useEditUser(id);
    const { companies, loading } = useCompaniesSelect();

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Editar Usuario</h1>
                <div className="row mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-7 mt-4 m-auto">
                        <div className="card mb-3">
                            <div className="pt-4 px-4 pt-md-5 px-md-5"> 
                                {/* Muestra el error del validator del backend */}
                                <ValidationErrors errors={validationErrors} onClose={clearMessages} />
                                <form onSubmit={(e) => {e.preventDefault();submit();}}>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingName" placeholder="Nombre" name="name" type="text" maxLength="100" value={form.name} onChange={handleChange} required />
                                        <label htmlFor="floatingName">Nombre *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                                                                            
                                            <input className="form-control" id="floatingLastname" placeholder="Apellidos" type="text" name="lastname" maxLength="100" value={form.lastname} onChange={handleChange} required />
                                            <label htmlFor="floatingLastname">Apellidos *</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <select className="form-select" id="floatingCompany" name="companyid" value={form.companyid || 1} onChange={handleChange} disabled={loading}>
                                                {companies.map(company => (
                                                <option key={company.id} value={company.id}>
                                                    {company.name}
                                                </option>
                                            ))}
                                            </select>
                                            <label htmlFor="floatingCompany">Empresa</label>
                                        </div>      
                                        <div className="form-floating mb-3">                                                                                            
                                                <input className="form-control" id="floatingUsername" placeholder="Nombre de usuario" type="text" name="username" autoComplete="username" maxLength="30" value={form.username} onChange={handleChange} required />
                                                <label htmlFor="floatingUsername">Nombre de usuario *</label>
                                        </div>                                                 
                                        <div className="form-floating mb-3">                                                                                            
                                            <input className="form-control" id="floatingEmail" placeholder="Email" type="email" name="email" autoComplete="email" maxLength="50" value={form.email} onChange={handleChange} required />
                                            <label htmlFor="floatingEmail">Email *</label>
                                        </div>
                                        <div className="form-floating mb-3">                                                                                            
                                            <input className="form-control" id="floatingPassword" placeholder="Dejar en blanco para no cambiar" type="password" name="password" autoComplete="new-password" maxLength="255" value={form.password || ''} onChange={handleChange}  />
                                            <label htmlFor="floatingPassword">Contraseña (opcional)</label>
                                        </div>
                                        <div className="form-floating mb-3">                                            
                                            <textarea className="form-control" id="floatingDescription" placeholder="Comentarios" name="description" maxLength="255" value={form.description || ''} onChange={handleChange} style={{height:"100px"}} ></textarea>
                                            <label htmlFor="floatingDescription">Comentarios</label>
                                        </div>
                                        <div className="mt-5 mb-4 text-end">                                            
                                            <button type="submit" className="btn btn-primary">Actualizar</button>
                                            <Link to={ROUTES.LISTUSER} className="btn btn-secondary ms-3">Cancelar</Link>                                            
                                        </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessModal
                show={!!success}
                message={success}
                onClose={() => navigate(ROUTES.LISTUSER)}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={clearMessages}
            />
        </>
    );
}